<script setup>
import { computed } from 'vue'
import { DateTimeInput } from '@addictivegroup/addictive-datetime'
import { toLocalInput, fromLocalInput } from '@/lib/format.js'

/** An instant (ISO 8601) edited as wall-clock time in the person's time zone (addictive-datetime). */
const props = defineProps({
  modelValue: { type: String, default: null },
  disabled: Boolean,
  invalid: Boolean,
  id: { type: String, default: '' },
  // 'future' for what is planned, 'past' for what happened: what "16" or "pt" means.
  direction: { type: String, default: 'any' },
})
const emit = defineEmits(['update:modelValue'])
const local = computed(() => toLocalInput(props.modelValue) || null)
</script>

<template>
  <DateTimeInput :id="id || undefined" :model-value="local" :direction="direction" :disabled="disabled" :invalid="invalid" @update:model-value="(v) => emit('update:modelValue', fromLocalInput(v))" />
</template>
